let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b8sPf")).then(() => parcelRequire('cZiB3'));